import axios from 'axios';

let prefix = "/content-management"

const ContentManagementApi = {
	
	getContentManagementList(payload){
		return axios.get( prefix + "/list", {params: payload})
	},
	getContentManagement(payload){
		return axios.get( prefix + "/get", {params: payload})
	},
	archiveContentManagement(payload){
		return axios.delete( prefix + "/delete", {params: payload})
	},
	createContentManagement(payload){
		return axios.post( prefix + "/create", payload)
	},
	updateContentManagement(payload){
		return axios.post( prefix + "/update", payload)
	},
	setContentManagementImage(payload, onUploadProgress = {} ){
		return axios.post(prefix + "/upload", payload,{
			headers: { 'Content-Type': 'multipart/form-data'},
			onUploadProgress
		})
	},
	clearContentManagementImage(payload){
		return axios.delete( prefix + "/delete-image", {params: payload})
	},
}

export default ContentManagementApi;